<template>
  <div class="entrust">
    <div class="top-head">
      <!-- <van-nav-bar title="我的委托" left-arrow @click-left="onClickLeft">
        <template #left>
          <van-icon name="arrow-left" color="black"/>
        </template>
      </van-nav-bar> -->

      <div class="center-nav">
        <div v-for="(item,index) in navList" :key="index" @click="onClickNav(item)" class="center-nav-all"
             :class="current_type === item ? 'center-nav-active' : 'center-nav-positive'">{{ item }}
        </div>
      </div>
    </div>
    <van-pull-refresh class="list-container" v-model="refreshing" @refresh="onRefresh">
      <van-list
          class="container"
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="请求失败，下拉刷新"
          @load="onLoad">
        <van-cell v-for="(unit,index) in list" :key="index">
          <template #title>
            <van-cell center :title="unit.title" title-class="van-cell-content-title"/>
            <van-cell v-for="(obj,index) in unit.option" :key="index" :title="obj.item" :value="obj.num" center
                      title-class="van-cell-title" value-class="van-cell-value"/>
            <div class="divider"></div>
          </template>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>

</template>


<script>
import api from '@/utils/api/personCenter'

export default {
  name: "Entrust",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      id:"",
      current_type: '进行中',
      navList: ["进行中", "已完成", "全部"],
      loading: false,
      error: false,
      finished: false,
      refreshing: false,
      list: this.updateList(0, 0, 0, 0, 0)
    };
  },
  computed: {},
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickNav(value) {
      this.current_type = value;
      this.fetchEntrustList(value)
    },

    onLoad() {
      this.fetchEntrustList(this.current_type)
    },
    onRefresh() {
      this.onLoad();
    },

    fetchEntrustList(type) {
      this.loading = true
      this.finished = false
      api.getEntrustList({
        userid: this.id,
        type: type
      })
          .then(res => {
            setTimeout(() => {
              this.loading = false
              this.finished = true
              this.refreshing = false
              this.error=false
              // console.log(res)
              this.list = this.updateList(res.GHCSNUM, res.GHGCNUM, res.FCYCHNUM, res.FCNUM, res.JGYSNUM,)
              // this.list = this.list.concat(this.updateList(res.GHCSNUM, res.GHGCNUM, res.FCYCHNUM, res.FCNUM, res.JGYSNUM))


            })
          }).catch(()=>{
            this.loading = false
            this.refreshing = false
            this.error=true
      })
    },
    updateList(GHCSNUM, GHGCNUM, FCYCHNUM, FCNUM, JGYSNUM) {
      return [
        // {
        //   title: '立项用地规划许可阶段',
        //   option: [
        //     {item: '土地供应测绘总数', num: 0},
        //     {item: '建设用地地籍调查总数', num: 0}
        //   ]
        // },
        {
          title: '工程规划许可阶段',
          option: [
            {item: '规划初始验线测量总数', num: GHCSNUM ? GHCSNUM : 0}
          ]
        },
        {
          title: '工程建设许可与施工监督阶段',
          option: [
            {item: '规划过程验线测量总数', num: GHGCNUM ? GHGCNUM : 0},
            {item: '房产面积预测绘', num: FCYCHNUM ? FCYCHNUM : 0},
          ]
        },
        {
          title: '竣工验收阶段',
          option: [
            {item: '竣工验收测量总数', num: JGYSNUM ? JGYSNUM : 0}
          ]
        },
        {
          title: '不动产登记阶段',
          option: [
            {item: '房产面积测绘总数', num: FCNUM ? FCNUM : 0}
          ]
        },
      ]
    }
  },
  filters: {},
  created() {
  },
  mounted(){
    this.id = this.$store.state.userInfo ? this.$store.state.userInfo.User_Id : "";
  },
  destroyed() {
  },
};
</script>

<style lang="scss" scoped>
.entrust {
  background-color: #ffffff;

  //头部导航
  .top-head {
    width: 100%;
    height: auto;
    overflow-y: auto;
    min-height: 60px;
    line-height: 1.5;
    z-index: 2;

    ::v-deep .van-nav-bar::after {
      border-bottom: none;
    }

    ::v-deep .van-nav-bar__left {
      padding-left: 10px;
    }

    ::v-deep .van-ellipsis {
      color: #000;
      font-size: 18px;
      height: 24px;
      line-height: 24px;
    }
  }

  .list-container{
    position: fixed;
    width: 100%;
    top: 44px;
    left: 0;
    height: calc(100% - 44px);
    overflow: auto;
    background-color: #ffffff;
  }
  //中间导航栏
  .center-nav {
    line-height: 1.5;
    // background-color: white;

    .center-nav-all {
      box-sizing: border-box;
      display: inline-block;
      font-size: 14px;
      text-align: center;
      width: 33.33%;
      border: 1px solid #dddddd;
      line-height: 1.5;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .center-nav-active {
      color: #1D85FF;
      font-weight: bold;

    }

    .center-nav-positive {
      color: #666666;
    }
  }


  .container {
    // height: calc(100vh - 90px);
    // height: 100vh;
    // overflow: auto;
  }

  //Item
  .van-cell-content-title {
    color: #999999;
    font-size: 12px;
    padding-left: 10px;
    padding-top: 10px;
  }

  .van-cell-title {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    padding-left: 10px;
    padding-bottom: 15px;
  }

  .van-cell-value {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    padding-right: 10px;
    padding-bottom: 15px;
  }

  ::v-deep .van-cell--center {
    padding: 0px;
  }

  ::v-deep .van-cell {
    padding: 0px;
  }

  ::v-deep .van-cell--center::after {
    border: none;
  }

  ::v-deep .van-cell::after {
    border: none;
  }

  .divider {
    height: 1px;
    box-sizing: border-box;
    background: #F1F3F6;
  }

}
</style>
